"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _drinkCardOrder = require("@/api/basic/drinkCardOrder");
var _drinkCardCouponLog = require("@/api/basic/drinkCardCouponLog");
var _drinkCardRefund = require("@/api/basic/drinkCardRefund");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 列表接口：GET /xyUserAccountBonus/orderPage（购买记录，默认 type=13 畅饮卡）
var _default = exports.default = {
  name: 'drinkCardOrder',
  data: function data() {
    return {
      loading: false,
      activeTab: 'all',
      searchForm: {
        orderSn: '',
        payStatus: null,
        page: 1,
        limit: 20
      },
      tableData: [],
      total: 0,
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      couponLogVisible: false,
      couponLogList: [],
      couponListVisible: false,
      couponListLoading: false,
      drinkCardItems: [],
      // 退款防重复点击
      refundLoading: false,
      refundingOrderSn: ''
    };
  },
  mounted: function mounted() {
    this.fetchList();
  },
  methods: {
    parseTime: _utils.parseTime,
    fetchList: function fetchList() {
      var _this = this;
      this.loading = true;
      (0, _drinkCardOrder.getDrinkCardOrderPage)(this.searchForm).then(function (res) {
        _this.tableData = res.records || [];
        _this.total = res.total || 0;
      }).catch(function () {
        _this.tableData = [];
        _this.total = 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleTabChange: function handleTabChange() {
      this.searchForm.payStatus = this.activeTab === 'all' ? null : Number(this.activeTab);
      this.searchForm.page = 1;
      this.fetchList();
    },
    handleFilter: function handleFilter() {
      this.searchForm.page = 1;
      this.fetchList();
    },
    resetSearch: function resetSearch() {
      this.activeTab = 'all';
      this.searchForm = {
        orderSn: '',
        payStatus: null,
        page: 1,
        limit: 20
      };
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      this.fetchList();
    },
    handleCouponLog: function handleCouponLog(row) {
      var _this2 = this;
      this.couponLogList = [];
      this.couponLogVisible = true;
      this._currentCouponOrderSn = row.orderSn;
      (0, _drinkCardCouponLog.getDrinkCardCouponLog)(row.orderSn).then(function (res) {
        _this2.couponLogList = res || [];
      });
    },
    handleRetry: function handleRetry(row) {
      var _this3 = this;
      (0, _drinkCardCouponLog.retryCouponLog)(row.id).then(function (res) {
        if (res.code === 200) {
          _this3.$message.success('重推成功');
          (0, _drinkCardCouponLog.getDrinkCardCouponLog)(_this3._currentCouponOrderSn).then(function (r) {
            _this3.couponLogList = r || [];
          });
        } else {
          _this3.$message.error(res.message || '重推失败');
        }
      });
    },
    grantIdsOf: function grantIdsOf(coupon) {
      return coupon && coupon.grantIds || [];
    },
    handleViewCoupons: function handleViewCoupons(row) {
      var _this4 = this;
      this.drinkCardItems = [];
      this.couponListVisible = true;
      this.couponListLoading = true;
      (0, _drinkCardCouponLog.getDrinkCardCouponGoodsList)(row.id).then(function (res) {
        _this4.drinkCardItems = Array.isArray(res) ? res : [];
      }).catch(function () {
        _this4.drinkCardItems = [];
      }).finally(function () {
        _this4.couponListLoading = false;
      });
    },
    isRefundingRow: function isRefundingRow(row) {
      if (!this.refundLoading || !row) return false;
      var sn = row.orderSn || row.tradeNo;
      return !!(this.refundingOrderSn && sn && String(this.refundingOrderSn) === String(sn));
    },
    clearRefundLock: function clearRefundLock() {
      this.refundLoading = false;
      this.refundingOrderSn = '';
    },
    handleRefund: function handleRefund(row) {
      var _this5 = this;
      if (this.refundLoading) {
        this.$message.warning('退款处理中，请勿重复点击');
        return;
      }
      var orderSn = row && (row.orderSn || row.tradeNo);
      if (!orderSn) {
        this.$message.error('订单号缺失');
        return;
      }
      // 一点击就上锁：列表「申请退款」立刻 loading/disabled（不必等点确认）
      this.refundLoading = true;
      this.refundingOrderSn = orderSn;
      this.$confirm('确认对订单 ' + orderSn + ' 发起退款？退款前将验证券是否全部未使用。', '退款确认', {
        confirmButtonText: '确认退款',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        distinguishCancelAndClose: true,
        beforeClose: function beforeClose(action, instance, done) {
          // 取消/关闭：放行并解锁
          if (action !== 'confirm') {
            _this5.clearRefundLock();
            done();
            return;
          }
          // 确认按钮防连点
          if (instance.confirmButtonLoading) return;
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '提交中...';
          (0, _drinkCardRefund.adminRefundDrinkCard)(orderSn).then(function (res) {
            // requestAuth：code=200 时整包返回；无 code 也视为成功
            var ok = !res || res.code === undefined || res.code === 200 || res.code === '200';
            if (ok) {
              _this5.$message.success(res && res.message || '退款申请成功');
              _this5.fetchList();
              _this5.clearRefundLock();
              done();
            } else {
              _this5.$message.error(res && res.message || '退款失败');
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = '确认退款';
              // 失败不关窗，列表仍保持 disabled，避免再点其它行；可再点确认重试或点取消
            }
          }).catch(function (err) {
            var msg = err && (err.message || err.msg) || err && err.data && err.data.message || '退款请求失败';
            _this5.$message.error(msg);
            instance.confirmButtonLoading = false;
            instance.confirmButtonText = '确认退款';
          });
        }
      }).then(function () {
        _this5.clearRefundLock();
      }).catch(function () {
        _this5.clearRefundLock();
      });
    },
    payStatusText: function payStatusText(s) {
      return {
        0: '未支付',
        1: '已支付',
        2: '已取消',
        4: '已退款'
      }[s] || '未知';
    },
    // xy_user_account_bonus.invoice_status：0未开票 1已申请 2已审核 3已开票
    invoiceStatusText: function invoiceStatusText(s) {
      var status = Number(s);
      if (status === 3) return '已开票';
      if (status === 1 || status === 2) return '开票中';
      return '-';
    },
    handleDownloadInvoice: function handleDownloadInvoice(row) {
      var url = row.redPdfUrl || row.pdfUrl;
      if (url) window.open(url, '_blank');
    }
  }
};